'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dAudit$002dPage$0024 from "./presto.-Audit-Page$.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002443 from "./presto.-Presto-Router$$anon$43.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$42() {
  this.biq = null;
  this.bii = null;
  this.bij = false;
  this.bir = null;
  this.bis = false;
  this.biv = null;
  this.bio = null;
  this.bip = false;
  this.bik = null;
  this.bil = false;
  this.bim = null;
  this.bin = false;
  this.bit = false;
  this.biu = false;
  this.biq = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.biv = "AuditPage";
}
export { $c_Lpresto_PrestoRouter$$anon$42 as $c_Lpresto_PrestoRouter$$anon$42 };
$p = $c_Lpresto_PrestoRouter$$anon$42.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$42;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$42() {
}
export { $h_Lpresto_PrestoRouter$$anon$42 as $h_Lpresto_PrestoRouter$$anon$42 };
$h_Lpresto_PrestoRouter$$anon$42.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.biq;
});
$p.L = (function() {
  if ((!this.bij)) {
    this.bii = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bij = true;
  }
  return this.bii;
});
$p.O = (function() {
  if ((!this.bis)) {
    this.bir = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bis = true;
  }
  return this.bir;
});
$p.E = (function() {
  return this.biv;
});
$p.t = (function() {
  if ((!this.bip)) {
    this.bio = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bip = true;
  }
  return this.bio;
});
$p.M = (function() {
  if ((!this.bil)) {
    this.bik = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bil = true;
  }
  return this.bik;
});
$p.Q = (function() {
  if ((!this.bin)) {
    this.bim = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002443.$c_Lpresto_PrestoRouter$$anon$43();
    this.bin = true;
  }
  return this.bim;
});
$p.w = (function() {
  if ((!this.biu)) {
    this.bit = false;
    this.biu = true;
  }
  return this.bit;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee363) => ((p) => \u03b4scrutinee363))($j_presto$002e$002dAudit$002dPage$0024.$m_Lpresto_AuditPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$42 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$42, "presto.PrestoRouter$$anon$42", ({
  O8: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$42 as $d_Lpresto_PrestoRouter$$anon$42 };
//# sourceMappingURL=presto.-Presto-Router$$anon$42.js.map
